import PropTypes from 'prop-types'
import React from 'react'

import { updateIntl } from 'locale.js'

class UpdateIntl extends React.PureComponent {

    static contextTypes = {
        intl: PropTypes.object,
    }

    componentWillMount() {
        updateIntl(this.context.intl)
    }

    render() {
        return null
    }
}
export default UpdateIntl



// WEBPACK FOOTER //
// ./containers/LocaleWrapper/components/UpdateIntl.js